import React from "react";
import { ButtonState, ButtonVariant, ButtonSize } from "../../../types";
import "./Button.css";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: ButtonVariant;
  size?: ButtonSize;
  state?: ButtonState;
  fullWidth?: boolean;
  className?: string;
  type?: "button" | "submit" | "reset";
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = "primary",
  size = "md",
  state = "default",
  fullWidth = false,
  className = "",
  type = "button",
}) => {
  return (
    <button
      type={type}
      className={`btn btn-${variant} btn-${size} btn-${state} ${
        fullWidth ? "btn-full-width" : ""
      } ${className}`}
      onClick={onClick}
      disabled={state === "disabled" || state === "loading"}
    >
      {state === "loading" ? (
        <>
          <span className="btn-loading-spinner"></span>
          <span>Loading...</span>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
